import { createAction } from 'typesafe-actions';

/**
 * The tenant opened a booking here, or closed one. Writing the value BACK to the host is the
 * caller's job (`useSelectBooking`), not the reducer's.
 *
 * ⭐ SEPARATE FROM `hydrateSelectedBooking` ON PURPOSE. The two carry the same payload and mean
 * different things, and only the reducer is in a position to tell them apart -- which is where the
 * race between them is settled.
 */
export const setSelectedBooking = createAction('SET_SELECTED_BOOKING')<string | null>();

/**
 * The host's stored selection, arriving on boot.
 *
 * ⚠️ YIELDS TO ANYTHING THE TENANT HAS ALREADY DONE. See `hasLocalSelection`.
 */
export const hydrateSelectedBooking = createAction('HYDRATE_SELECTED_BOOKING')<string | null>();
